import { useFeatureFlagEnabled } from 'posthog-js/react'

import { useAuth } from '@app/context/auth'

/**
 * Resolves the Knowledge Hub URL for the current user's region.
 * The 'new-access-knowledge-hub-link' feature flag only applies to UK users.
 */
export const useKnowledgeHubUrl = () => {
  const { acl } = useAuth()
  const newAccessKnowledgeHubLinkEnabled = useFeatureFlagEnabled(
    'new-access-knowledge-hub-link',
  )

  if (!acl.isUK()) {
    return import.meta.env.VITE_KNOWLEDGE_HUB_URL_ANZ
  }

  return newAccessKnowledgeHubLinkEnabled
    ? import.meta.env.VITE_KNOWLEDGE_HUB_URL_NEW
    : import.meta.env.VITE_KNOWLEDGE_HUB_URL
}
